<span *ngIf="size === iconSize.regular">
  <svg height="40"
       width="40">
    <circle cx="20" cy="20"
            r="19" stroke="gray"
            [attr.stroke-width]="strokeWidth.toString()"
            [attr.fill]="'#' + colorHex"></circle>
    <text x="20" y="22" dominant-baseline="middle" text-anchor="middle"
          style="font-weight: bold;font-size: 18px;" [ngStyle]="{'fill': textColor}">
      {{ iconInitials }}
    </text>
  </svg>
</span>

<span *ngIf="size === iconSize.small">
  <svg height="32"
       width="32">
    <circle cx="16" cy="16"
            r="15" stroke="gray"
            [attr.stroke-width]="strokeWidth.toString()"
            [attr.fill]="'#' + colorHex"></circle>
    <text x="16" y="17" dominant-baseline="middle" text-anchor="middle"
          style="font-weight: bold;font-size: 14px;" [ngStyle]="{'fill': textColor}">
      {{ iconInitials }}
    </text>
  </svg>
</span>

<span *ngIf="size === iconSize.extraSmall">
  <svg height="24"
       width="24">
    <circle cx="12" cy="12"
            r="11" stroke="gray"
            [attr.stroke-width]="strokeWidth.toString()"
            [attr.fill]="'#' + colorHex"></circle>
    <text x="12" y="13" dominant-baseline="middle" text-anchor="middle"
          style="font-weight: bold;font-size: 10px;" [ngStyle]="{'fill': textColor}">
      {{ iconInitials }}
    </text>
  </svg>
</span>
